export const blockIconsNotificationPowerOff = (
	<span className='material-symbols-outlined'>power_off</span>
);
